import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import FreeCreditEvaluationWrapper from "@components/layouts/freeCreditEvaluationWrapper";

import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";

export default function FreeCreditEvaluationHome(): ReactElement {
    return (
        <FreeCreditEvaluationWrapper>
            <TermsAndConditions
                category="Credit Repair"
                domain="FreeCreditEvaluation.com"
            />
        </FreeCreditEvaluationWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
